module.exports = __webpack_public_path__ + "img/ico-telegram.34a2ac56.svg";